import { render, staticRenderFns } from "./InvoiceReminder.vue?vue&type=template&id=54e52058"
import script from "./InvoiceReminder.vue?vue&type=script&lang=js"
export * from "./InvoiceReminder.vue?vue&type=script&lang=js"
import style0 from "./InvoiceReminder.vue?vue&type=style&index=0&id=54e52058&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports